@import '../../../global/global.scss';
cms-countdown-timer {
  color: #333;
  .cms-ends-in-text {
    white-space: nowrap;
  }
  .cms-timer {
    direction: ltr;
    unicode-bidi: isolate;
    display: flex;
    align-items: center;
    > div {
      display: flex;
      align-items: center;
    }
  }
  &.cms-default,
  &.cms-color-bg,
  &.cms-gradient-bg,
  &.cms-bordered,
  &.cms-black-white {
    font-weight: bold;
    .cms-timer {
      margin: 0px 2px;
    }
    .cms-digit {
      padding: 4px 7px;
      border-radius: 5px;
    }
    .cms-letter {
      font-weight: normal;
      padding: 0px 4px;
    }
  }
  &.cms-tiny {
    font-size: 12px;
    .cms-digit {
      padding: 4px 5px;
    }
    .cms-colon {
      margin: 0px 2px;
    }
  }
  &.cms-mini {
    font-size: 14px;
    .cms-digit {
      padding: 4px 5px;
    }
    .cms-colon {
      margin: 0px 2px;
    }
  }
  &.cms-small {
    font-size: 16px;
    .cms-colon {
      margin: 0px 4px;
    }
  }
  &.cms-middle {
    font-size: 18px;
    .cms-colon {
      margin: 0px 6px;
    }
  }
  &.cms-large {
    font-size: 24px;
    .cms-digit {
      padding: 7px 10px;
    }
    .cms-colon {
      margin: 0px 8px;
    }
  }
  &.cms-bordered {
    .cms-digit,
    .cms-digit-and-letter {
      border: 1px solid #cccccc;
    }
  }
  &.cms-black-white {
    .cms-digit,
    .cms-digit-and-letter {
      border: 1px solid #000;
      color: #000;
      background-color: #fff;
    }
  }
  &.cms-default {
    .cms-digit,
    .cms-digit-and-letter {
      background-color: #fff;
    }
  }
  &.cms-gradient-bg,
  &.cms-color-bg {
    .cms-digit,
    .cms-digit-and-letter {
      color: #fff;
    }
  }
  &.cms-text-only {
    gap: 4px;
    .cms-timer {
      gap: 4px;
    }
    .cms-digit {
      margin: 0px;
      padding: 0px;
    }
    .cms-colon {
      margin: 0px;
    }
  }
  &.cms-ends-nowrap {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  &.cms-ends-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .cms-ends-in-text {
      line-height: 2;
    }
  }

  &.cms-capsule {
    font-weight: bold;
    .cms-timer {
      margin: 0px 4px;
      color: #fff;
      .cms-digit {
        padding: 0px;
      }
    }
  }
  &.cms-capsule.cms-mini,
  &.cms-capsule.cms-tiny {
    .cms-timer {
      padding: 4px 10px;
      border-radius: 14px;
    }
  }
  &.cms-capsule.cms-small {
    .cms-timer {
      padding: 4px 12px;
      border-radius: 15px;
    }
  }
  &.cms-capsule.cms-middle {
    .cms-timer {
      padding: 4px 14px;
      border-radius: 18px;
    }
  }
  &.cms-capsule.cms-large {
    .cms-timer {
      padding: 7px 18px;
      border-radius: 23px;
    }
  }
  &.cms-lowercase-letter {
    .cms-timer {
      text-transform: lowercase;
    }
  }

  &.cms-digit-round {
    .cms-digit {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      padding: 0px;
    }
  }
  &.cms-digit-round.cms-tiny {
    .cms-timer {
      .cms-digit {
        width: 28px;
        height: 28px;
      }
    }
  }
  &.cms-digit-round.cms-mini {
    .cms-timer {
      .cms-digit {
        width: 30px;
        height: 30px;
      }
    }
  }
  &.cms-digit-round.cms-small {
    .cms-timer {
      .cms-digit {
        width: 34px;
        height: 34px;
      }
    }
  }
  &.cms-digit-round.cms-middle {
    .cms-timer {
      .cms-digit {
        width: 38px;
        height: 38px;
      }
    }
  }
  &.cms-digit-round.cms-large {
    .cms-timer {
      .cms-digit {
        width: 50px;
        height: 50px;
      }
    }
  }

  &.cms-digit-and-letter-round {
    font-weight: bold;
    .cms-timer {
      margin: 0px 2px;
      .cms-digit-and-letter {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        .cms-digit {
          padding: 0px;
          margin: 0px;
          border: none;
          background-color: transparent;
        }
        .cms-letter {
          padding: 0px;
        }
      }
    }
  }

  &.cms-digit-and-letter-round.cms-tiny {
    .cms-timer {
      .cms-digit-and-letter {
        width: 32px;
        height: 32px;
      }
    }
  }
  &.cms-digit-and-letter-round.cms-mini {
    .cms-timer {
      .cms-digit-and-letter {
        width: 35px;
        height: 35px;
      }
    }
  }
  &.cms-digit-and-letter-round.cms-small {
    .cms-timer {
      .cms-digit-and-letter {
        width: 40px;
        height: 40px;
      }
    }
  }
  &.cms-digit-and-letter-round.cms-middle {
    .cms-timer {
      .cms-digit-and-letter {
        width: 45px;
        height: 45px;
      }
    }
  }
  &.cms-digit-and-letter-round.cms-large {
    .cms-timer {
      .cms-digit-and-letter {
        width: 58px;
        height: 58px;
      }
    }
  }

  &.cms-compact {
    font-weight: bold;
    .cms-timer {
      margin: 0px 2px;
      .cms-digit-and-letter {
        color: #fff;
        padding: 2px 8px;
        line-height: 1.5;
        .cms-digit {
          padding: 0px;
          margin: 0px;
          border: none;
          background-color: transparent;
        }
        .cms-letter {
          font-weight: 700;
          padding: 0px;
        }
      }
    }
  }
  &.cms-black-white {
    .cms-timer {
      .cms-digit-and-letter {
        color: #000;
      }
    }
  }
  &.cms-compact.cms-mini,
  &.cms-compact.cms-tiny {
    .cms-timer {
      .cms-digit-and-letter {
        border-radius: 4px;
        padding: 0px 6px;
      }
    }
    .cms-colon {
      margin: 0px 4px;
    }
  }
  &.cms-compact.cms-tiny {
    .cms-timer {
      .cms-digit-and-letter {
        padding: 1px 6px;
      }
    }
  }
  &.cms-compact.cms-small {
    .cms-timer {
      .cms-digit-and-letter {
        border-radius: 6px;
      }
    }
  }
  &.cms-compact.cms-middle {
    .cms-timer {
      .cms-digit-and-letter {
        border-radius: 8px;
        padding: 2px 10px;
      }
    }
  }
  &.cms-compact.cms-large {
    .cms-timer {
      .cms-digit-and-letter {
        border-radius: 10px;
        padding: 2px 12px;
      }
    }
  }

  &[data-theme='text-only'][data-is-show-colon='true'] {
    .cms-timer {
      gap: 0px;
    }
  }
  &.cms-digit-split {
    .cms-digit-wrapper {
      display: flex;
      justify-items: center;
      gap: 4px;
    }
  }

  &.cms-digit-split.cms-tiny {
    font-size: 14px;
    .cms-digit-wrapper {
      gap: 2px;
    }
    .cms-digit {
      padding: 1px 5px;
      border-radius: 6px;
    }
  }
  &.cms-digit-split.cms-mini {
    font-size: 16px;
    .cms-digit {
      padding: 0;
      width: 20px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      border-radius: 6px;
    }
    .cms-colon {
      margin: 0px 4px;
    }
  }
  &.cms-digit-split.cms-small {
    font-size: 18px;
    .cms-digit {
      padding: 1px 5.5px;
      border-radius: 6px;
    }
    .cms-colon {
      margin: 0px 4px;
    }
  }
  &.cms-digit-split.cms-middle {
    font-size: 24px;
    .cms-digit {
      padding: 0px;
      border-radius: 6px;
      width: 26px;
      height: 32px;
      text-align: center;
      line-height: 32px;
    }
    .cms-colon {
      margin: 0px 4px;
    }
  }
  &.cms-digit-split.cms-large {
    font-size: 28px;
    .cms-digit {
      padding: 0px;
      border-radius: 6px;
      width: 28px;
      height: 36px;
      text-align: center;
      line-height: 36px;
    }
    .cms-colon {
      margin: 0px 4px;
    }
  }
}
